import { render, staticRenderFns } from "./DeleteCollectionModal.vue?vue&type=template&id=3cd59421&"
import script from "./DeleteCollectionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports